import React, {
	useState,
	useEffect
} from "react";
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography
} from "@mui/material";
import { StatusBox } from "../../Shared/StatusBox/StatusBox";

export default function UnsyncedOrderTable({ data }) {

	const [state, setState] = useState({
		isLoading: false,
		unsyncedOrderSummary: [],
	});

	const page_data = {
		unsynced_orders: data,
	};

	useEffect(() => {
		setState(previousState => ({
			...previousState,
			unsyncedOrderSummary: page_data.unsynced_orders.results,
			isLoading: page_data.unsynced_orders.isLoading,
		}));
	},
	[
		page_data.unsynced_orders.results,
		page_data.unsynced_orders.isLoading,
	]
	);

	if (state.isLoading) {
		return <Typography>Loading...</Typography>;
	}

	return (
		<Paper sx={{ p: 2, width: "100%" }} elevation={2}>
			<Typography variant="h6" sx={{ mt: 1, mb: 4 }}>Unsynced Orders</Typography>
			<Table stickyHeader>
				<TableHead>
					<TableRow>
						<TableCell className="table-header">Status</TableCell>
						<TableCell className="table-header">Orders</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{state.unsyncedOrderSummary.map((o, i) =>
						<TableRow key={i}>
							<TableCell>
								<StatusBox 
									status={o.reason} 
									statusType={"order"}
								/>
							</TableCell>
							<TableCell>{o.orders}</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</Paper>
	);
}